import React, { useState, useRef, useEffect } from 'react'
import { withTransaction } from '@elastic/apm-rum-react'
import AppBatteriesManagementDeleteView from './view'
import store from '../../store'
import request from '../../utils/request'
import { ActionType } from '../../store/error/actions'

function AppBatteriesManagementDelete(): JSX.Element {
  const [isLoading, setIsLoading] = useState(false)
  const [disableButton, setDisableButton] = useState(true)
  const [snackIsShown, setSnackIsShown] = useState(false)
  const [snackMessage, setSnackMessage] = useState('')
  const [snackSeverity, setSnackSeverity] = useState<
    'error' | 'warning' | 'info' | 'success'
  >('info')
  const [batteriesFile, setBatteriesFile] = useState<File | Blob | string>('')
  const [displayBubbleText, setDisplayBubbleText] = useState<boolean>(false)
  const ref = useRef<HTMLInputElement | null>(null)

  function onCloseNotificationListener(
    event?: React.SyntheticEvent,
    reason?: string
  ): void {
    if (reason === 'clickaway') return
    setSnackIsShown(false)
  }

  function handleFile(event: React.ChangeEvent<HTMLInputElement>) {
    const file = event.target.files ? event.target.files.item(0) : undefined
    if (file) {
      setBatteriesFile(file)
      const reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      reader.onload = function (evt) {
        const text = evt?.target?.result || ''
        if (
          text
            ?.toString()
            .replace(/[^\w/_"'áñéíóú<>*&%$(),;.\-¿?=!>\s]/gi, '') != text
        ) {
          const newText = text
            ?.toString()
            .replace(/[^\w/_"'áñéíóú<>*&%$(),;.\-¿?=!>\s]/gi, '')
          const blob = new Blob([newText], { type: 'text/csv' })
          const generatedFile = new File([blob], 'Draft1.csv', {
            type: 'text/cs'
          })
          setBatteriesFile(generatedFile)
        }
      }
    }
  }

  useEffect(() => {
    if (batteriesFile) {
      setDisableButton(false)
    }
  }, [batteriesFile])

  function deleteBatteriesFromFile() {
    setIsLoading(true)

    const form_data = new FormData()
    form_data.append('file', batteriesFile)

    const batteriesInstall = request.postFormDataRequest(
      'api/batteries/csv-bulk-delete',
      form_data
    )()
    batteriesInstall.response
      .then(() => {
        const file = (batteriesFile as File) ? (batteriesFile as File).name : ''
        setSnackMessage(`The file ${file} has been imported`)
        setSnackSeverity('success')
        setSnackIsShown(true)
      })
      .catch((error) => {
        setDisplayBubbleText(true)
        const errorMessage = error.message.slice(
          error.message.indexOf('ERROR') + 'ERROR'.length,
          error.message.indexOf('.,')
        )
        const error400 = <span>{errorMessage}.</span>
        if (error instanceof DOMException) return
        store.dispatch({
          type: ActionType.SET_BY_STATUS,
          payload: {
            statusCode: error.status,
            message: error.status === 400 ? error400 : error.message
          }
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <AppBatteriesManagementDeleteView
      disableButton={disableButton}
      batteriesFile={batteriesFile}
      onFileLoad={handleFile}
      isLoading={isLoading}
      onRemoveBatteries={deleteBatteriesFromFile}
      snackbar={{
        open: snackIsShown,
        body: <p>{snackMessage}</p>,
        severity: snackSeverity,
        onClose: onCloseNotificationListener,
        duration: 4000
      }}
      inputRef={ref}
      displayBubbleText={displayBubbleText}
      onCloseBubbleText={setDisplayBubbleText}
    />
  )
}

export default withTransaction(
  'AppBatteriesManagementStockControl',
  'component'
)(AppBatteriesManagementDelete)
